import { render, staticRenderFns } from "./ApplicationHistory.vue?vue&type=template&id=550d25a7"
import script from "./ApplicationHistory.vue?vue&type=script&lang=ts"
export * from "./ApplicationHistory.vue?vue&type=script&lang=ts"
import style0 from "./ApplicationHistory.vue?vue&type=style&index=0&id=550d25a7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports